import appStore from 'store';
import api from './api';

const store ={
    namespaced: true,
    state: {
        infoList:[]
    },
    mutations:{
        setInfoList(state,payload) {
            state.infoList = payload;
        }
    },
    actions:{
        pushChinese({commit},data) {
            return api.pushChineseContent(data);
        },

        pushEnglish({commit},data) {
            return api.pushEnglishContent(data);
        },
        queryQuotationPushConf({commit},data) {
            api.getQuotationPushConf(data).then(response => {
                commit('setInfoList',response.data);
            })
        }
    }
}

appStore.registerModule('pushSetting',store);